import { renderToStaticMarkup } from 'react-dom/server'
import { resolveFormatter } from '~/components/echarts/formatters'
import { TooltipCircle } from '~/components/echarts/tooltip_circle'

function Tooltip({ name, value, color, formatter, percent }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', marginTop: '4px' }}>
      <TooltipCircle color={color} />
      <div style={{ paddingLeft: '4px', marginRight: 'auto' }}>{name}</div>
      <div style={{ paddingLeft: '8px', fontWeight: 'bold' }}>
        {formatter(value)} ({percent}%)
      </div>
    </div>
  )
}

export function pieTooltipFormatter(formatter, currency) {
  const formatterFunction = typeof formatter === 'function' ? formatter : resolveFormatter(formatter, currency)

  return (params) => {
    const { color, name, percent, value } = params
    return renderToStaticMarkup(
      <Tooltip name={name} color={color} value={value} percent={percent} formatter={formatterFunction} />,
    )
  }
}
